<template>
  <wt-box :class="classes" :style="'width:' + size + ';height:'  + size + ';'">
      <slot />
    </wt-box>
</template>

<script>
import wtBox from '../box'
// 组件class前缀
const prefixCls = 'wt-avatar'

export default {
  name: 'wt-avatar',
  props: {
    size: {
      type: [String]
    }
  },
  components: {
    wtBox
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style lang="less">
.wt-avatar{
    border-radius: 100%;
    overflow: hidden;
    >img,
    >.wt-img{
        width:101%;
        height:101%;
    }
}
</style>
